export const PRIMARY_TOKEN = 'token';
// every authenticated response may carry a refreshed session jwt in this header.
export const SESSION_JWT_HEADER = 'x-horizon-api-session-jwt';
export const COMPANY_SELECTOR_SELECTED_COMPANY_STORAGE_KEY =
  'companySelector_selectedCompany';
export const PLAY_STORE_LINK =
  'https://play.google.com/store/apps/details?id=io.tread.horizon.android';
export const APPLE_STORE_LINK =
  'https://apps.apple.com/us/app/tread-horizon/id6449744081';
export const TREAD_TERMS_LINK = 'https://tread.io/tread-terms-of-subscription/';
export const TREAD_PRIVACY_POLICY_LINK = 'https://tread.io/privacy-policy';
export const TREAD_DOCS_URL = 'https://docs.tread.ai';
export const OMNI_DASHBOARDS_BASE_URL = 'https://tread.omniapp.co/dashboards';
export const OMNI_APPS_BASE_URL = 'https://tread.omniapp.co/apps';
// horizon-api requires this content id on builder rows.
export const OMNI_BUILDER_CONTENT_ID = 'entity-folder';

export const GLOBAL_DEBOUNCE_DEBOUNCE_DELAY_IN_MS = 150;

// Matches the api's default page size.
export const DEFAULT_API_PAGE_SIZE = 25;

// Matches the api's max page size.
export const MAX_API_PAGE_SIZE = 100;

// Matches the api's max page size for location histories.
export const MAX_LOCATION_HISTORY_PAGE_SIZE = 1000;

// Most rows a CSV export loads before it asks the user to narrow the filters.
export const EXPORT_ROW_LIMIT = 50_000;

/**
 * Maximum number of loads per job/truck.
 * When job splitting is enabled (job.splittable), the limit is extended to 50.
 */
export const DEFAULT_MAX_LOADS_COUNT = 25;
export const SPLITTABLE_MAX_LOADS_COUNT = 50;

// Lives here, not in `connectionModule`, so `~utils/sentry/sentry-reporting-utils`
// can read it without the two importing each other.
export const API_BASE_URL = import.meta.env.TREAD__BASE_URL || 'http://localhost:8000';
